import React, { FC, useState } from 'react';

import { NativeResources } from '@ariksa/inventory-core';
import { HStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-use';

import { PrimaryIconButton } from 'components/DataEntry';
import { DownloadIcon, LinkIcon } from 'components/Icons';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';
import { actions } from 'containers/ActiveCloudResource/slice';
import { useAccessBoundary } from 'containers/App/hooks/useAccessBoundary';
import { selectApp } from 'containers/App/selectors';
import { saveAsFile } from 'utils/download';

export const VulnerabilityTabActions: FC = () => {
  const {
    resourceId,
    resourceUuid,
    resourceAccountId,
    downloadReport,
    resourceType,
  } = useSelector(selectActiveResource);
  const dispatch = useDispatch();
  const { environmentId } = useAccessBoundary();
  const pageLocation = useLocation();
  const { user } = useSelector(selectApp);
  const [isCopied, setIsCopied] = useState(false);

  return (
    <HStack>
      <PrimaryIconButton
        aria-label="copy link"
        tooltip={
          isCopied ? 'Copied to clipboard' : 'Copy link for vulnerabilities'
        }
        tooltipW={32}
        showGrayBg
        onClick={() => {
          setIsCopied(true);
          navigator.clipboard.writeText(
            (
              pageLocation.origin +
              '/visibility/vulnerability/resource/' +
              resourceUuid +
              '?organization=' +
              user.info.org_id
            ).toString(),
          );
        }}
      >
        <LinkIcon />
      </PrimaryIconButton>
      {resourceType !== NativeResources.AmazonMachineImage && (
        <PrimaryIconButton
          aria-label="download"
          tooltip="Download all open vulnerabilities as CSV"
          isLoading={downloadReport.isLoading}
          tooltipW={32}
          showGrayBg
          onClick={() => {
            dispatch(
              actions.downloadReport({
                q: {
                  accountId: [resourceAccountId],
                  environmentId,
                  resourceId: [resourceUuid],
                  resourceType: resourceType,
                },
                onSuccess: res => {
                  saveAsFile(
                    res,
                    'Ariksa - Vulnerabilities_' +
                      resourceId +
                      '_' +
                      dayjs().format('DD-MMM-YYYY h.mm A') +
                      '.csv',
                    'text/csv;charset=utf-8;',
                  );
                },
              }),
            );
          }}
        >
          <DownloadIcon />
        </PrimaryIconButton>
      )}
    </HStack>
  );
};
